import React from 'react';
import classNames from 'classnames';

interface KnobToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

export default function KnobToggle({ value, onChange, className }: KnobToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      onClick={() => onChange(!value)}
      className={classNames(
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer items-center rounded-full transition-colors focus:outline-none',
        value ? 'bg-primary' : 'bg-secondary-200',
        className,
      )}>
      <span
        aria-hidden
        className={classNames(
          'inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform',
          value ? 'translate-x-6' : 'translate-x-1',
        )}
      />
    </button>
  );
}
